import { useMemo } from 'react'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { TSpecs } from '@/shared/types/product-types'
import { Button } from '@/shared/ui'
import { Col, Row } from '@/shared/ui/Grid'
import { Title } from '@/shared/ui/Typography'

import { useSpecsContext } from '../../../../api/SpecsContext'

import { SpecGroup } from './spec-group/spec-group'

import cl from './styles.module.scss'

export type TechSpecsTabProps = {
	productTitle: string
	items: TSpecs
}

export const TechSpecsTab = ({ productTitle, items }: TechSpecsTabProps): JSX.Element => {
	const { isSpecsExpanded, expandSpecs, collapseSpecs } = useSpecsContext()
	const specs = useMemo(() => Object.values(items), [items])

	// Функция для переключения состояния
	const toggleCollapse = () => {
		isSpecsExpanded ? collapseSpecs() : expandSpecs()
	}

	return (
		<section className={!isSpecsExpanded && specs.length > 4 ? cl.specs : ``}>
			<Title level={`2`}>
				<span dangerouslySetInnerHTML={createMarkup(`Характеристики ${productTitle}`)} />
			</Title>
			<Row>
				{/* Первый блок всегда видим */}
				{specs.length > 0 && (
					<Col xs={24} key={specs[0].GROUP_NAME}>
						<SpecGroup items={specs[0].GROUP_PROPERTIES} title={specs[0].GROUP_NAME} isCollapsed={false} />
					</Col>
				)}
				{/* Остальные блоки управляются состоянием из контекста */}
				{specs.slice(1).map(specGroup => (
					<Col xs={24} key={specGroup.GROUP_NAME}>
						<SpecGroup items={specGroup.GROUP_PROPERTIES} title={specGroup.GROUP_NAME} isCollapsed={!isSpecsExpanded} />
					</Col>
				))}
			</Row>
			{specs.length > 1 && (
				<Button theme="link" onClick={toggleCollapse}>
					{isSpecsExpanded ? 'Свернуть' : 'Читать полностью'}
				</Button>
			)}
		</section>
	)
}
